/* eslint-disable no-restricted-globals */
/* eslint-disable react-hooks/exhaustive-deps */
import moment from "moment";
import React, { useEffect, useState } from "react";
import { BiPlus, BiTrash } from "react-icons/bi";
import { FaEye } from "react-icons/fa";
import { GoBriefcase } from "react-icons/go";
import AppButton from "../../common/AppButton";
import AppModal from "../../common/AppModal";
import Table from "../../common/Table";
import Body from "../../components/Body";
import SearchInput from "../../components/SearchInput";
import api from "../../config/api";
import useHeader from "../../hooks/useHeader";
import { observer } from "mobx-react-lite";
import { cloneDeep } from "lodash";
import { toast } from "react-toastify";
import { useLocation, useNavigate } from "react-router-dom";
import TableMenu from "../../components/TableMenu";
import QuotationCreateModel from "./QuotationCreateModel";
import { getQuotations } from "../../stores/QuotationStore";
import { useQuery, useQueryClient } from "@tanstack/react-query";
const header = [
  { name: "quoteId", title: "Quote ID", filter: "Search" },
  { name: "location", title: "Job Location", filter: "Search" },
  { name: "quotationIssueDate", title: "Quote Issued Date" },
];
function QuotationList() {
  const navigate = useNavigate();
  const { setHeader } = useHeader();
  const location = useLocation();
  const { pathname } = location;
  const [model, setModel] = useState({
    visible: false,
  });
  const queryClient = useQueryClient();

  const { data: quotations } = useQuery({
    queryFn: () => getQuotations(),
    queryKey: ["quotations"],
  });

  const [skip, setSkip] = useState(0);
  const LIMIT = 100;
  useEffect(() => {
    setHeader("Quotations");
    // load();
  }, []);

  const data = quotations?.slice(0, skip + LIMIT).map((qt) => {
    return {
      ...qt,
      quotationIssueDate: moment(qt.quotationIssueDate).format("DD/MM/YYYY"),
    };
  });

  const handleDelete = async (quote) => {
    if (window.confirm("Are you sure want to delete the quotation ?") === false)
      return false;
    const res = await api.put("quotations", {
      _id: quote._id,
      isDeleted: true,
    });
    if (!res.ok) return toast.error(res.originalError.message);

    queryClient.invalidateQueries(["quotations"]);
    toast.success("Job has been successfully deleted");
  };

  const [loadingMore, setLoadingMore] = useState(false);
  const handleCreateQuotation = () => {
    navigate(`/quotations/createQuotation`);
  };

  const handleView = (quote) => {
    const id = quote._id;
    const path = `${pathname}/${id}/quotationToPdf`;
    navigate(path);
  };

  const handleCreateJob = (quote) => {
    const id = quote._id;
    const path = `${pathname}/${id}/quotationToPdf`;
    navigate(path);
  };

  const handleLoadMore = async () => {
    setSkip(skip + LIMIT);
  };

  const [spinning, setSpinning] = useState(false);
  const [searched, setsearched] = useState(false);
  const handleSearch = async (value) => {
    setSpinning(true);
    setsearched(true);
    const res = await api.get("jobs/search", { value });
    if (!res.ok) {
      setSpinning(false);
      alert(res.originalError.message);
    }
    if (res.ok) {
      // setData(
      //   res.data?.map((i) => {
      //     return {
      //       ...i,
      //       location: i.location.title,
      //       client: i.organization.name,
      //       startDate: moment(i.jobStartDate).format("DD/MM/YYYY"),
      //       endDate: moment(i.jobEndDate).format("DD/MM/YYYY"),
      //       status: job.jobStatus({ job: i }),
      //     };
      //   })
      // );
      setSpinning(false);
    }
  };

  const QuoteModel = QuotationCreateModel();

  return (
    <div>
      <Body noPadding>
        <div style={{ flex: 1 }}>
          {/* <SearchInput spinning={spinning} onSubmit={handleSearch} /> */}
          <TableMenu>
            <AppButton
              tooltip="Create Quotation"
              onClick={handleCreateQuotation}
              leftIcon={<BiPlus size={35} />}
              className="btn"
            />
            {/* <AppButton
            onClick={handleCreateQuotation}
            text="Create Job"
            className="text-primary btn-light"
          /> */}
          </TableMenu>
          <Table
            header={header}
            data={data}
            SideButtons={({ inv }) => {
              return (
                <div className="side-button">
                  <AppButton
                    onClick={() => handleView(inv)}
                    tooltip="View"
                    className="text-primary"
                    leftIcon={<FaEye />}
                  />
                  <AppButton
                    onClick={() => {
                      setModel({
                        visible: true,
                        // header: <Org.Header organization={init} />,
                        model: (
                          <QuoteModel.Body
                            quotation={inv}
                            onDone={async () => {
                              queryClient.invalidateQueries(
                                ["quotations"],
                                ["jobs"]
                              );
                              setModel({ visible: false });
                            }}
                          />
                        ),
                        // footer: <Org.Footer organization={init} />,
                      });
                    }}
                    leftIcon={<GoBriefcase />}
                    tooltip="Create Job"
                    className="text-primary"
                  />

                  <AppButton
                    onClick={() => handleDelete(inv)}
                    tooltip="Delete Quotation"
                    className="text-primary"
                    leftIcon={<BiTrash />}
                  />
                </div>
              );
            }}
          />

          <AppModal
            onHide={() => {
              setModel({});
            }}
            {...model}
          />
        </div>
      </Body>
      {!searched && data?.length > 0 && (
        <div
          style={{
            display: "flex",
            justifyContent: "center",
            marginBottom: 20,
          }}
        >
          <AppButton
            onClick={handleLoadMore}
            text="Load more..."
            className="btn-secondary"
            disabled={loadingMore}
          />
        </div>
      )}
    </div>
  );
}
export default observer(QuotationList);
